import { useCallback, useEffect, useState } from 'react'
import type { Repository } from '../services/storage/repositories'

export function useRepository<T extends { id: string }>(repository: Repository<T>) {
  const [items, setItems] = useState<T[]>([])
  const [loading, setLoading] = useState(true)
  const refresh = useCallback(async () => { setItems(await repository.list()); setLoading(false) }, [repository])
  useEffect(() => { void refresh() }, [refresh])
  return { items, loading, refresh }
}
